<template>
<v-container fluid fill-height class="pa-0">
    <v-layout v-if="errorMessage">
        <v-flex>
            <v-alert 
                :value="true" 
                outline 
                type="error">
                <span>{{ errorMessage }}</span>
            </v-alert>
        </v-flex>
    </v-layout>
    <loading v-if="loading"></loading>
    <v-layout v-if="!loading && !errorMessage">
        <v-flex>
            <PlantConfigurationSeasonsTable :data="plantSeasons" @edit="openEdit" @deleteComplete="deleteComplete"></PlantConfigurationSeasonsTable>
        </v-flex>
    </v-layout>
    <PlantConfigurationSeasonsAddEdit
        v-if="showAddEditDialog"
        :plantID="plantID"
        :show="showAddEditDialog"
        :originalItem="editedItem"
        @close="onAddEditClose"
        :productCategories="productCategories"
        >
    </PlantConfigurationSeasonsAddEdit>
</v-container>
</template>

<script>
import BaseAPI from "@/api/baseApi";
import plantConfigurationApi from '@/api/plantConfigurationApi'
import Loading from '@/components/generic/Loading.vue';
import PlantConfigurationSeasonsTable from '@/components/plants/configuration/PlantConfigurationSeasonsTable.vue'
import PlantConfigurationSeasonsAddEdit from '@/components/plants/configuration/PlantConfigurationSeasonsAddEdit.vue'

export default {
    props: {
        plantID: {
            required: true,
            type: Number
        }
    },
    components: {
        Loading,
        PlantConfigurationSeasonsTable,
        PlantConfigurationSeasonsAddEdit
    },
    data() {
        return {
            errorMessage: null,
            loading: false,
            showAddEditDialog: false,
            editedItem: null,
            plantSeasons: [],            
            productCategories:[]
        };
    },
    methods: {
        async loadData() {
            try {
                this.loading = true;

                this.plantSeasons = await plantConfigurationApi.getPlantSeasons(this.plantID);                
                this.productCategories = await plantConfigurationApi.getActiveProductCategories();                
            }
            catch (err) {
                this.errorMessage = await BaseAPI.parseHttpRequestError(err);

                throw err;
            }
            finally {
                this.loading = false;
            }
        },
        async openEdit(item) {
            this.editedItem = item;
            this.showAddEditDialog = true;
        },
        async onAddEditClose(saved) {
            this.showAddEditDialog = false;            

            if (saved === true) {
                await this.loadData();
            }
        },
        async deleteComplete(errorMessage) {
            await this.loadData();
            if (errorMessage) {
                this.errorMessage = errorMessage;
            }
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
